import {on, find, findAll} from '@elements/dom-utils';
import {animatedTeaser} from "js/scripts/utils";
import {onFind} from "@elements/init-modules-in-scope";

const defaultOptions = {};

export function init(options = defaultOptions){
    for (const [key, value] of Object.entries({...defaultOptions, ...options})){
        defaultOptions[key] = value;
    }

    onFind('.js-ajax-form-animated', function (element) {
        on('fetch.ajax-form', (evt) => {
            const form = evt.target;
            form.classList.add('is-loading');
        }, element);

        on('success.ajax-form', (evt) => {
            formSuccess(evt);
        }, element);

        on('product-grid.success', (evt) => {
            formSuccess(evt)
        }, element);
    });

    animatedTeaser(findAll('.js-ajax-form-animated__item.animated'));
}

function formSuccess(evt){
    const form = evt.target;
    form.classList.remove('is-loading');
    setTimeout(function(){
        animatedTeaser(findAll('.js-ajax-form-animated__item.animated'));
    }, 50);
}